/** @format */
import '@js/shared-sessions.js';
/**
 * Priority booking button logic
 */

jQuery(function($) {
	// Don't perform session sharing check if on 404 page
	// To reduce AJAX requests on multiple hits
	if ($('body').hasClass('error404')) {
		return
	}

	const $accountNav = $('#account-nav');

	if($accountNav.length) {

		const $loginLink = $('#c-login-link');
		const $logoutLink = $('#c-logout-link');
		const currentUrl = `${window.location.origin}${window.location.pathname}`;

		$loginLink.attr('href', `${$loginLink.attr('href')}?ReturnURL=${encodeURIComponent(currentUrl)}`);
		$logoutLink.attr('href', `${$logoutLink.attr('href')}?ReturnURL=${encodeURIComponent(currentUrl + "?logout=true")}`);

		if ($.fn.sharedSession) {
			const urlParams = new URLSearchParams(window.location.search);

			if (urlParams.has('logout')) {
				localStorage.removeItem('shared-session-session');
				localStorage.removeItem('shared-session-cart');
			} else {
				$accountNav.sharedSession('session', {
					debug: true,
					success: function (response) {
						$('body').addClass(function () {
							let classes = ['shared-session__active', 'shared-session__user'];

							if (response.sessions && response.sessions.IsLoggedIn) {
								classes.push('shared-session__user-logged-in');
							} else {
								classes.push('shared-session__user-logged-out');
							}

							return classes.join(' ');
						});
					},
				});
			}
		}

	}

})
